
"use strict"; // jshint ignore:line

import { ObjectPropertyHandler } from "../../utils/object-properties/object-property-handler.js";

export default class ContextMenuService {

	static $inject = [ "$rootScope", "$compile", "$templateRequest", "$timeout" ];

	constructor( $rootScope, $compile, $templateRequest, $timeout ) {

		var service = window.ContextMenuService = this;
		var modals    = this.modals = {};
		var templateScopes = {};

		this.elemTriggers = {};

		var arrangement;

		this.setArrangement = function( _arrangement) {
			arrangement = _arrangement || null;
			for (var key in modals) modals[key].$scope.arrangement = arrangement;
		};

		this.init = function( key, templateUrl, data ){
			if (modals[ key ]) this.destroy( key );

			modals[ key ] = templateUrl ? (new ContextMenuModal( templateUrl, data )) : ContextMenuModal.byKey( key, data );

		};
		
		this.run = function( key, x, y, extend, options = {} ) {

			if (!modals[ key ]) return console.warn("ContextMenuModal '"+ key +"' not found");

			this.closeAll( key );

			for (var label in templateScopes[ modals[ key ].templateUrl ]) {
				modals[ key ].$scope[ label ] = templateScopes[ modals[ key ].templateUrl ][ label ];
			}

			modals[ key ].run( x, y, extend, options );
		};
		this.closeAll = function( but ){
			for( var key in modals ){
				if( key == but ) continue;
				if( modals[ key ]) modals[ key ].close();
				else delete modals[ key ];
			}
		};
		this.destroy = this.remove = function( key ){
			if( !modals[ key ]) return console.warn("Unable to destroy contextMenu '"+key+"', not found");

			modals[ key ].destroy();
			delete modals[ key ];
		};
		this.changeKey = function( old, key ){
			if( modals[ old ]){
				modals[ old ].close();
				modals[ key ] = modals[ old ];

				delete modals[ old ];
			}
		};
		this.buildTemplateScope = function( templateUrl, scope ){
			if( !Array.isArray( templateUrl )) templateUrl = [ templateUrl ];

			for( var i in templateUrl) templateScopes[ templateUrl[i] ] = scope;
		};

		function ContextMenuModal( templateUrl, data ){
			var self           = this;
			this.$scope        = $rootScope.$new( true );
			this.$scope.data   = this.data = data = data || {};
			this.$scope.$modal = this;
			this.$scope.contextMenuService = service;
			this.$scope.objectPropertyHandler = ObjectPropertyHandler;
			this.$scope.arrangement = arrangement;
			this.$scope.tmp    = {};
			this.$scope.$close = function(){ self.close(); };
			this.templateUrl   = templateUrl;

			if (typeof data.constructor == "function") {
				this.constructor = data.constructor.bind( this.$scope );
			} else if (data.constructor) {
				throw "Invalid argument!";
			} else {
				this.constructor = function(){ };
			}

			this.templateHtml = $templateRequest( templateUrl )
			.catch(function( error ){
				console.error( error );
				return templateUrl;
			})
			.then(function( html ){
				self.templateHtml = "<aside class='disable-top-offset context-menu' ng-class='key' data-template-url='{{ $modal.templateUrl }}'><b class='glyphicon glyphicon-remove' ng-click='$close()'></b>"+ html +"</aside>";
			});

			this.$scope.keepNumberFixed = function keepNumberFixed( val, exp, fallback ){
				exp = Math.pow( 10, exp || 0 );
				var nval = Math.round( val * exp ) / exp;

				if (( nval == null || isNaN( nval ))) return fallback != null ? fallback : val;
				return nval;
			};
		}
		ContextMenuModal.prototype.destroy = function(){
			this.close();
			this.$scope && this.$scope.$destroy();
		}
		ContextMenuModal.prototype.close = function(){
			this.elem && this.elem.remove();
			this.elem = null;
		}
		ContextMenuModal.prototype.run = function( x, y, extend, options = { size: undefined } ){

			const top_bar_offset_px = 52;
			const nice_margin_px    = 10;
			
			var self = this;

			this.$$x = x;
			this.$$y = y;

			this.$scope.extend = extend || {};

			this.constructor( x, y, extend );

			if (!this.elem) {
				this.elem = angular.element( this.templateHtml );
				$compile( this.elem )( this.$scope );
				document.body.append( this.elem[ 0 ]);
			}

			try {
				resetPosition( this.elem[0], { x, y, size: options.size });
			} catch( err ) { console.error( err ); }

			try {
				if (typeof this.$scope.onOpen == "function") this.$scope.onOpen.call( this.$scope );
			} catch( err ) { console.error( err ); }

			return this;

			function resetPosition( elem, { x, y, size }) {

				elem.style.maxHeight  = `${ window.innerHeight - top_bar_offset_px - 2 * nice_margin_px }px`;
				elem.style.visibility = "visible";

				if (size == "full") {
					elem.style.left       = `${ nice_margin_px }px`;
					elem.style.right      = `${ nice_margin_px }px`;
					elem.style.top        = `${ top_bar_offset_px + nice_margin_px }px`;
					elem.style.bottom     = `${ nice_margin_px }px`;

					elem.style.maxHeight  = `${ window.innerHeight - 2 * nice_margin_px }px`;
					elem.style.maxWidth   = `${ window.innerWidth  - 2 * nice_margin_px }px`;

				} else {
					$timeout(function(){
						var pos = calcPos( elem, x, y );
						elem.style.left       = `${ pos.x }px`;
						elem.style.top        = `${ pos.y }px`;
		
						contextMenuToDraggable( self );
					}, 99);
				}
			}

			function calcPos( elem, x, y ) {

				let width = elem.scrollWidth;
				let height = elem.scrollHeight;

				try {
					let rect = elem.getBoundingClientRect();
					width  = rect.width;
					height = rect.height;
				} catch (error) {
					console.error( error );
				}

				if (width >= 0 && height >= 0) {
					x = Math.max( 0, Math.min( window.innerWidth  - elem.scrollWidth  - 10, x ));
					y = Math.max( 0, Math.min( window.innerHeight - elem.scrollHeight - 10, y ));
				}

				return { x, y };
			}
		};

		ContextMenuModal.byKey = function( key, data ) {
			var path = "templates/context-modal-template."+ key +".html";
			var menu = new ContextMenuModal( path, data );
			menu.$scope.key = key;
			return menu;
		};
	}
}


/** @param {ContextMenuModal} menu */
function contextMenuToDraggable( menu ) {
	if (!menu.elem || !menu.elem[0]) return;

	/** @link: https://www.w3schools.com/howto/howto_js_draggable.asp */
	var elmnt = menu.elem[0];
	var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
	elmnt.onmousedown = dragMouseDown;

	var ignoreElemTags = ["INPUT","A","BUTTON","SELECT","TEXTAREA"];

	function dragMouseDown(e) {
		e = e || window.event;

		if (e.target && ignoreElemTags.indexOf( e.target.tagName.toUpperCase() ) != -1) return;
		if (e.target.parentElement && ignoreElemTags.indexOf( e.target.parentElement.tagName.toUpperCase() ) != -1) return;

		e.preventDefault();
		// get the mouse cursor position at startup:
		pos3 = e.clientX;
		pos4 = e.clientY;
		document.onmouseup = closeDragElement;
		// call a function whenever the cursor moves:
		document.onmousemove = elementDrag;
	}

	function elementDrag(e) {
		e = e || window.event;
		e.preventDefault();
		// calculate the new cursor position:
		pos1 = pos3 - e.clientX;
		pos2 = pos4 - e.clientY;
		pos3 = e.clientX;
		pos4 = e.clientY;
		// set the element's new position:
		elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
		elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
	}

	function closeDragElement() {
		// stop moving when mouse button is released:
		document.onmouseup = null;
		document.onmousemove = null;
	}
}
